'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Normalizes the offset value.
 * @param {number|array} value The value to normalize.
 * @returns {number}
 */
exports.default = function (value) {
  return typeof value === 'number' || typeof value === 'string' ? [value, value] : value;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/~/semantic-ui-react/dist/commonjs/lib/normalizeOffset.js
 ** module id = 2881
 ** module chunks = 0
 **/